import { DataSourceType } from '@/models/dataSource';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { SourceConnectorCatalogItem } from '../sourceConnectors/useSourceConnectorCatalogItems';
import { DataSourceTypeCard } from './DataSourceTypeCard';
import { SourceConnectorCatalogCard } from './SourceConnectorCatalogCard';

type SourceAwareCatalogGridProps = {
  standardTypes: DataSourceType[];
  sourceConnectorItems: SourceConnectorCatalogItem[];
  onStandardTypeClick: (source: DataSourceType) => void;
  onConnect: (item: SourceConnectorCatalogItem) => void;
  onManage: (item: SourceConnectorCatalogItem) => void;
} & PropsWithChildren;

export const SourceAwareCatalogGrid: FC<SourceAwareCatalogGridProps> = ({
  standardTypes,
  sourceConnectorItems,
  onStandardTypeClick,
  onConnect,
  onManage,
  children,
}) => {
  const rows: ReactNode[] = [
    ...standardTypes.map((source) => <DataSourceTypeCard key={source.id} dataSourceType={source} onClick={() => onStandardTypeClick(source)} />),
    ...sourceConnectorItems.map((item) => (
      <SourceConnectorCatalogCard key={item.dataSourceType.id} item={item} onConnect={() => onConnect(item)} onManage={() => onManage(item)} />
    )),
  ];

  return (
    <div className='grid max-w-[58.875rem] grid-cols-1 gap-8 pt-4 md:grid-cols-2 md:gap-8 xl:grid-cols-3'>
      {rows}
      {children}
    </div>
  );
};
